/* eslint-disable max-len */
/*!
 * @ngx-dummy/Accordion-Simple library
 * Simple accordion created for angular / ionic projects.
 * https://github.com/ngx-dummy/accordion-simple
 *
 * Copyright  Vladimir Ovsyukov <ovsyukov@yandex.com>
 * Published under GNU LGPLv3 License
 */
export const logo_svg =
	'<svg width="50" height="50" viewBox="0 0 50 50" fill="white" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C2.23858 0 0 2.23858 0 5V45C0 47.7614 2.23858 50 5 50H45C47.7614 50 50 47.7614 50 45V5C50 2.23858 47.7614 0 45 0H5ZM11 10C10.4477 10 10 10.4477 10 11V15C10 15.5523 10.4477 16 11 16H39C39.5523 16 40 15.5523 40 15V11C40 10.4477 39.5523 10 39 10H11ZM10 23C10 22.4477 10.4477 22 11 22H39C39.5523 22 40 22.4477 40 23V27C40 27.5523 39.5523 28 39 28H11C10.4477 28 10 27.5523 10 27V23ZM11 34C10.4477 34 10 34.4477 10 35V39C10 39.5523 10.4477 40 11 40H32C32.5523 40 33 39.5523 33 39V35C33 34.4477 32.5523 34 32 34H11Z"/></svg>';

export const arrow_down =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="48px" height="48px"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path d="M0 0h24v24H0V0z" fill="none"/></svg>';
